import { DataCenter, getDataCenter } from '../../env'
import { PmitcCustomer } from '../Customer/Data'

const dcAuProd = 'au'
const dcAuStaging = 'au-staging'
const dcAuTest = 'au-test'
const dcCaProd = 'ca'
const dcEuProd = 'eu'
const dcUkProd = 'uk'
export const dcUsGenesis = 'us-genesis'

export function getPmitcDcDisplayName(dc: string): string {
  switch (dc) {
    default:
      return '?' + dc + '?'
    case '':
      return 'Select data center'
    case dcAuProd:
      return 'Australia'
    case dcAuStaging:
      return 'Australia (staging)'
    case dcAuTest:
      return 'Australia (test)'
    case dcCaProd:
      return 'Canada'
    case dcEuProd:
      return 'European Union'
    case dcUkProd:
      return 'United Kingdom'
    case dcUsGenesis:
      return 'United States'
  }
}

export function getPmitcDcShortName(dc: string): string {
  if (dc === dcUsGenesis) {
    return 'us'
  }

  return dc
}

// Print management in the cloud (Hive/Pocket) data centers
export function getPmitcDcs(): string[] {
  // The first PMITC data center in the list is the default for the given Multiverse data center
  // If there is more than one PMITC data center in the same region as the Multiverse data center, the default should be
  // empty, and the list should be ordered with the PMITC data centers in-region followed by those outside
  // PMITC test/staging data centers must not be listed in Multiverse production data centers and vice versa
  switch (getDataCenter()) {
    default:
      return ['', dcUsGenesis, dcCaProd, dcAuProd, dcEuProd, dcUkProd]
    case DataCenter.Test:
    case DataCenter.Staging:
      return ['', dcAuStaging, dcAuTest]
    case DataCenter.AU:
      return [dcAuProd, dcCaProd, dcEuProd, dcUkProd, dcUsGenesis]
    case DataCenter.EU:
      return [dcEuProd, dcAuProd, dcCaProd, dcUkProd, dcUsGenesis]
    case DataCenter.UK:
      return [dcUkProd, dcAuProd, dcCaProd, dcEuProd, dcUsGenesis]
  }
}

export const getPmitcOrgRef = (customer: PmitcCustomer): string =>
  getPmitcDcShortName(customer.dataCenter) + ':' + customer.orgId

export interface AccountProfile {
  dataCenter: string
}

export interface Subscription {
  orgId: string
  orgName: string
  partnerName: string
  partnerCode: string
}
